import { Link, Typography } from '@montugroup/design-system';
import { Link as RouterLink } from 'react-router-dom';

import { PROFILE_DETAILS_ROUTE } from '@/routes/route-paths';

/**
 * Offers go out, and are accepted, by text, so a patient without a mobile is asked to add one.
 */
export const AddMobilePrompt = ({ children }: { children: string }) => (
  <Typography variant="body1">
    <Link component={RouterLink} to={PROFILE_DETAILS_ROUTE}>
      Add a mobile number to your profile
    </Link>{' '}
    {children}
  </Typography>
);
